import { flags } from '@/core/components/ui/EIcon/flags';
import { phoneMasks } from '@/core/consts/masks';

export type Country = {
  name: string;
  flag: string;
  mask: string;
};

export const countries: Record<string, Country> = {
  RU: {
    name: 'Россия, +7',
    flag: flags.RU,
    mask: phoneMasks.RU,
  },
  AZ: {
    name: 'Азербайджан, +994',
    flag: flags.AZ,
    mask: phoneMasks.AZ,
  },
  AM: {
    name: 'Армения, +374',
    flag: flags.AM,
    mask: phoneMasks.AM,
  },
  BY: {
    name: 'Беларусь, +375',
    flag: flags.BY,
    mask: phoneMasks.BY,
  },
  GE: {
    name: 'Грузия, +995',
    flag: flags.GE,
    mask: phoneMasks.GE,
  },
  KZ: {
    name: 'Казахстан, +7',
    flag: flags.KZ,
    mask: phoneMasks.KZ,
  },
  KG: {
    name: 'Кыргыстан, +996',
    flag: flags.KG,
    mask: phoneMasks.KG,
  },
  TJ: {
    name: 'Таджикистан, +992',
    flag: flags.TJ,
    mask: phoneMasks.TJ,
  },
  UZ: {
    name: 'Узбекистан, +998',
    flag: flags.UZ,
    mask: phoneMasks.UZ,
  },
};
